'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _STARTER$PROFESSIONAL;

var _Editions = require('self-service-api/constants/Editions');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_STARTER$PROFESSIONAL = {}, _defineProperty(_STARTER$PROFESSIONAL, _Editions.STARTER, null), _defineProperty(_STARTER$PROFESSIONAL, _Editions.PROFESSIONAL, _MerchandiseIds.SERVICE_PROFESSIONAL_SUITE_ONBOARDING), _defineProperty(_STARTER$PROFESSIONAL, _Editions.ENTERPRISE, _MerchandiseIds.SERVICE_ENTERPRISE_SUITE_ONBOARDING), _STARTER$PROFESSIONAL);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/GrowthSuiteEditionOnboardingMerchIdMap.js
// module id = 229
// module chunks = 3 4 5